import React, { useEffect, useRef, useState } from 'react';
import PePapersDisclaimerGate from './shared/PePapersDisclaimerGate';
import { createPortal } from 'react-dom';
import { X } from 'lucide-react';
import { savePePapersArchiveDoc } from '../../services/pePapersArchiveService';
import useAppStore from '../../store/appStore';
import { buildHtmlAsPdfBlob, downloadHtmlAsPdf } from '../../utils/pe-papers/htmlDocumentPdfDownload';

const MR_CONTRACT_PDF_CSS = `
  .av-a4-page {
    display: flex !important;
    flex-direction: column !important;
    width: 100% !important;
    max-width: 210mm !important;
    min-height: 297mm !important;
    margin-left: auto !important;
    margin-right: auto !important;
    box-sizing: border-box !important;
    font-family: Georgia, 'Times New Roman', serif !important;
    color: #0f172a !important;
    font-size: 12.5px !important;
    line-height: 1.42 !important;
    /* Unten bewusst mehr Rand, damit Signaturen nicht am Blattrand kleben */
    padding: 10mm 12mm 16mm 12mm !important;
    background: #ffffff !important;
  }
  .av-a4-page * { box-sizing: border-box !important; }
  .av-a4-page .pdf-letterhead {
    width: 100% !important;
    text-align: center !important;
    border-bottom: 2px solid #1e293b !important;
    margin: 0 0 10px !important;
    padding: 0 0 8px !important;
    flex-shrink: 0 !important;
  }
  .av-a4-page .pdf-letterhead h1 {
    font-family: Arial, Helvetica, sans-serif !important;
    font-size: 17px !important;
    font-weight: 900 !important;
    letter-spacing: 0.1em !important;
    text-transform: uppercase !important;
    color: #0f172a !important;
    background: transparent !important;
    border: none !important;
    padding: 0 !important;
    margin: 0 0 3px !important;
    text-align: center !important;
  }
  .av-a4-page .pdf-letterhead h2 {
    font-family: Arial, Helvetica, sans-serif !important;
    font-size: 12px !important;
    font-weight: 700 !important;
    letter-spacing: 0.16em !important;
    text-transform: uppercase !important;
    color: #b48a56 !important;
    background: transparent !important;
    border: none !important;
    padding: 0 !important;
    margin: 0 !important;
    text-align: center !important;
  }
  .av-meta-grid {
    display: table !important;
    width: 100% !important;
    table-layout: fixed !important;
    margin: 0 0 10px !important;
    border: 1px solid #cbd5e1 !important;
    background: #f8fafc !important;
    flex-shrink: 0 !important;
  }
  .av-meta-col {
    display: table-cell !important;
    width: 50% !important;
    vertical-align: top !important;
    padding: 8px 10px !important;
    font-size: 12.5px !important;
    line-height: 1.35 !important;
    color: #334155 !important;
    text-align: left !important;
  }
  .av-meta-col + .av-meta-col { border-left: 1px solid #e2e8f0 !important; }
  .av-meta-label {
    display: block !important;
    font-family: Arial, Helvetica, sans-serif !important;
    font-size: 11.5px !important;
    font-weight: 700 !important;
    text-transform: uppercase !important;
    letter-spacing: 0.12em !important;
    color: #64748b !important;
    margin: 0 0 4px !important;
  }
  .av-meta-col strong { color: #0f172a !important; font-weight: 700 !important; }
  .av-meta-col p {
    width: 100% !important;
    margin: 0 !important;
    text-align: left !important;
    font-size: 12px !important;
    line-height: 1.4 !important;
    color: #334155 !important;
  }
  .av-meta-col .av-meta-date {
    display: block !important;
    margin-top: 4px !important;
    color: #64748b !important;
    font-size: 11px !important;
  }
  .av-doc-body {
    display: block !important;
    width: 100% !important;
    flex: 1 1 auto !important;
  }
  .av-doc-section {
    display: block !important;
    width: 100% !important;
    margin: 0 0 7px !important;
  }
  .av-a4-page h3,
  .av-doc-section > h3 {
    display: block !important;
    width: 100% !important;
    font-family: Arial, Helvetica, sans-serif !important;
    font-size: 11px !important;
    font-weight: 700 !important;
    text-transform: uppercase !important;
    letter-spacing: 0.05em !important;
    text-align: left !important;
    background: #1e293b !important;
    color: #f8fafc !important;
    border: none !important;
    border-radius: 0 !important;
    padding: 4px 9px !important;
    margin: 0 0 4px !important;
  }
  .av-a4-page p,
  .av-doc-p,
  .av-doc-section p {
    display: block !important;
    width: 100% !important;
    max-width: 100% !important;
    font-family: Georgia, 'Times New Roman', serif !important;
    font-size: 12.5px !important;
    line-height: 1.4 !important;
    color: #1e293b !important;
    text-align: justify !important;
    margin: 0 0 4px !important;
  }
  .ab-sig-table {
    width: 100% !important;
    border-collapse: collapse !important;
    table-layout: fixed !important;
    margin-top: auto !important;
    padding-top: 12px !important;
    border: none !important;
    flex-shrink: 0 !important;
  }
  .ab-sig-table td {
    width: 50% !important;
    vertical-align: top !important;
    border: none !important;
    background: transparent !important;
    padding: 0 !important;
  }
  .ab-sig-table p {
    text-align: left !important;
    margin: 0 !important;
    width: auto !important;
    max-width: 100% !important;
    font-family: Arial, Helvetica, sans-serif !important;
  }
  @media print {
    @page { size: A4; margin: 0; }
    body { margin: 0 !important; padding: 0 !important; background: #fff !important; }
    .av-a4-page {
      box-shadow: none !important;
      margin: 0 !important;
      max-width: none !important;
      width: 100% !important;
      min-height: 297mm !important;
    }
  }
`;

interface ModellReleaseModalProps {
    isOpen: boolean;
    onClose: () => void;
    initialData?: any;
    onArchived?: () => void;
}

interface SalonFormData {
    firmenname: string;
    strasse: string;
    plz: string;
    ort: string;
    mailadresse: string;
    telefon: string;
}

interface ModellFormData {
    name: string;
    strasse: string;
    plz: string;
    ort: string;
    geburtsdatum: string;
}

interface SalonFieldLocks {
    firmenname: boolean;
    strasse: boolean;
    plz: boolean;
    ort: boolean;
    mailadresse: boolean;
    telefon: boolean;
}

const INITIAL_MODELL_DATA: ModellFormData = {
    name: '',
    strasse: '',
    plz: '',
    ort: '',
    geburtsdatum: '',
};

const A4_PREVIEW_PAGE_CLASS =
    'av-a4-page bg-white text-slate-900 my-4 mx-auto w-full max-w-[210mm] h-auto min-h-0 shadow-xl rounded-sm text-left block overflow-visible print:my-0 print:shadow-none';

const DOC_P_CLASS = 'av-doc-p mb-2 text-justify text-slate-800 leading-relaxed';

const INPUT_CLASS =
    'w-full rounded-lg border border-pe-border dark:border-slate-700 bg-pe-input dark:bg-black text-pe-text dark:text-white px-4 py-2.5 text-sm focus:outline-none focus:border-[#E6C299]/50 transition-colors';

const LABEL_CLASS = 'text-xs font-semibold text-pe-muted dark:text-slate-400 uppercase tracking-wider mb-1 block';

const READONLY_INPUT_CLASS =
    'w-full rounded-lg border border-pe-border dark:border-slate-700 bg-pe-elevated dark:bg-[#0a0a0a] text-pe-accent-text dark:text-[#E6C299] px-4 py-2.5 text-sm cursor-not-allowed opacity-90';

const ERROR_INPUT_RING = 'border-red-500 focus:border-red-500 focus:ring-1 focus:ring-red-500/20';

const STEP_LABELS: Record<number, string> = {
    1: 'Datenerfassung',
    2: 'Vorschau & Export',
};

const SALON_AUTOCOMPLETE: Record<keyof SalonFormData, string> = {
    firmenname: 'organization',
    strasse: 'street-address',
    plz: 'postal-code',
    ort: 'address-level2',
    mailadresse: 'email',
    telefon: 'tel',
};

const formatGermanDate = (value: string): string => {
    if (!value.trim()) return '____________';
    return value.trim();
};

const formatTodayGerman = (): string => {
    const now = new Date();
    const dd = String(now.getDate()).padStart(2, '0');
    const mm = String(now.getMonth() + 1).padStart(2, '0');
    const yyyy = now.getFullYear();
    return `${dd}.${mm}.${yyyy}`;
};

const isEmpty = (value: string) => !String(value || '').trim();

const isValidEmail = (value: string) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value.trim());

/** Legacy-Archiv: einzeilige `adresse` → Straße / PLZ / Ort */
const parseLegacyAdresse = (adresse: string): Pick<ModellFormData, 'strasse' | 'plz' | 'ort'> => {
    const raw = String(adresse || '').trim();
    if (!raw) return { strasse: '', plz: '', ort: '' };

    const lines = raw
        .split(/[\n;]+/)
        .map((s) => s.trim())
        .filter(Boolean);

    const plzOrtMatch = (value: string) => {
        const m = value.match(/^(\d{4,5})\s+(.+)$/);
        return m ? { plz: m[1], ort: m[2].trim() } : null;
    };

    if (lines.length === 1) {
        const parts = lines[0]
            .split(',')
            .map((s) => s.trim())
            .filter(Boolean);
        if (parts.length >= 2) {
            const last = plzOrtMatch(parts[parts.length - 1]);
            if (last) {
                return {
                    strasse: parts.slice(0, -1).join(', '),
                    plz: last.plz,
                    ort: last.ort,
                };
            }
        }
        const single = plzOrtMatch(lines[0]);
        if (single) return { strasse: '', ...single };
        return { strasse: lines[0], plz: '', ort: '' };
    }

    const lastLine = plzOrtMatch(lines[lines.length - 1]);
    if (lastLine) {
        return {
            strasse: lines.slice(0, -1).join(', '),
            plz: lastLine.plz,
            ort: lastLine.ort,
        };
    }
    return { strasse: lines[0], plz: '', ort: lines.slice(1).join(' ') };
};

const normalizeModellData = (incoming: any): ModellFormData => {
    const src = incoming && typeof incoming === 'object' ? incoming : {};
    const hasStructured =
        !isEmpty(String(src.strasse || '')) ||
        !isEmpty(String(src.plz || '')) ||
        !isEmpty(String(src.ort || ''));
    if (!hasStructured && typeof src.adresse === 'string' && src.adresse.trim()) {
        const parsed = parseLegacyAdresse(src.adresse);
        return {
            name: String(src.name || ''),
            strasse: parsed.strasse,
            plz: parsed.plz,
            ort: parsed.ort,
            geburtsdatum: String(src.geburtsdatum || ''),
        };
    }
    return {
        name: String(src.name || ''),
        strasse: String(src.strasse || ''),
        plz: String(src.plz || ''),
        ort: String(src.ort || ''),
        geburtsdatum: String(src.geburtsdatum || ''),
    };
};

const formatModellAdresseInline = (data: ModellFormData): string => {
    const line1 = data.strasse.trim();
    const line2 = [data.plz.trim(), data.ort.trim()].filter(Boolean).join(' ');
    return [line1, line2].filter(Boolean).join(', ');
};

const buildSalonFromClient = (clientData: any): { salon: SalonFormData; locks: SalonFieldLocks } => {
    const firmenname = clientData?.salonname || clientData?.firmenname || '';
    const strasse = clientData?.strasse || '';
    const plz = clientData?.plz || '';
    const ort = clientData?.ort || '';
    const mailadresse = clientData?.mailadresse || '';
    const telefon = clientData?.whatsappNr || '';

    return {
        salon: { firmenname, strasse, plz, ort, mailadresse, telefon },
        locks: {
            firmenname: !isEmpty(firmenname),
            strasse: !isEmpty(strasse),
            plz: !isEmpty(plz),
            ort: !isEmpty(ort),
            mailadresse: !isEmpty(mailadresse),
            telefon: !isEmpty(telefon),
        },
    };
};

const ModellReleaseModal: React.FC<ModellReleaseModalProps> = ({ isOpen, onClose, initialData, onArchived }) => {
    const [currentStep, setCurrentStep] = useState(1);
    const [salonData, setSalonData] = useState<SalonFormData>({
        firmenname: '',
        strasse: '',
        plz: '',
        ort: '',
        mailadresse: '',
        telefon: '',
    });
    const [salonLocks, setSalonLocks] = useState<SalonFieldLocks>({
        firmenname: false,
        strasse: false,
        plz: false,
        ort: false,
        mailadresse: false,
        telefon: false,
    });
    const [modellData, setModellData] = useState<ModellFormData>(INITIAL_MODELL_DATA);
    const [invalidFields, setInvalidFields] = useState<Set<string>>(new Set());
    const [disclaimerAccepted, setDisclaimerAccepted] = useState(false);
    const [isSaving, setIsSaving] = useState(false);
    const [isPdfDownloading, setIsPdfDownloading] = useState(false);
    const [archiveFeedback, setArchiveFeedback] = useState<'idle' | 'success' | 'error' | 'draft'>('idle');
    const [archiveDocId, setArchiveDocId] = useState<string | null>(null);

    const printContainerRef = useRef<HTMLDivElement>(null);

    const clientData = useAppStore((state: any) => state.clientData);

    useEffect(() => {
        if (!isOpen) {
            setCurrentStep(1);
            setModellData(INITIAL_MODELL_DATA);
            setInvalidFields(new Set());
            setDisclaimerAccepted(false);
            setIsSaving(false);
            setArchiveFeedback('idle');
            setArchiveDocId(null);
            return;
        }

        const { salon, locks } = buildSalonFromClient(clientData);
        setSalonData(salon);
        setSalonLocks(locks);
        setCurrentStep(1);
        setModellData(INITIAL_MODELL_DATA);
        setInvalidFields(new Set());
        setDisclaimerAccepted(false);
        setIsSaving(false);
        setArchiveFeedback('idle');
        setArchiveDocId(initialData?.id || null);

        if (initialData) {
            if (initialData.salonData && typeof initialData.salonData === 'object') {
                setSalonData({ ...salon, ...initialData.salonData });
                setSalonLocks({
                    firmenname: !isEmpty(String(initialData.salonData.firmenname ?? salon.firmenname)),
                    strasse: !isEmpty(String(initialData.salonData.strasse ?? salon.strasse)),
                    plz: !isEmpty(String(initialData.salonData.plz ?? salon.plz)),
                    ort: !isEmpty(String(initialData.salonData.ort ?? salon.ort)),
                    mailadresse: !isEmpty(String(initialData.salonData.mailadresse ?? salon.mailadresse)),
                    telefon: !isEmpty(String(initialData.salonData.telefon ?? salon.telefon)),
                });
            }
            if (initialData.modellData && typeof initialData.modellData === 'object') {
                setModellData(normalizeModellData(initialData.modellData));
            }
            const step = Number(initialData.currentStep);
            if (Number.isFinite(step) && step >= 1 && step <= 2) {
                setCurrentStep(step);
            }
            if (initialData.confirmedDisclaimer) {
                setDisclaimerAccepted(true);
            }
        }
    }, [isOpen, clientData, initialData]);

    const validateStep1 = (): string[] => {
        const errors: string[] = [];

        if (isEmpty(salonData.firmenname)) errors.push('salon_firmenname');
        if (isEmpty(salonData.strasse)) errors.push('salon_strasse');
        if (isEmpty(salonData.plz)) errors.push('salon_plz');
        if (isEmpty(salonData.ort)) errors.push('salon_ort');
        if (isEmpty(salonData.mailadresse) || !isValidEmail(salonData.mailadresse)) errors.push('salon_mailadresse');
        if (isEmpty(salonData.telefon)) errors.push('salon_telefon');

        if (isEmpty(modellData.name)) errors.push('modell_name');
        if (isEmpty(modellData.strasse)) errors.push('modell_strasse');
        if (isEmpty(modellData.plz)) errors.push('modell_plz');
        if (isEmpty(modellData.ort)) errors.push('modell_ort');
        if (isEmpty(modellData.geburtsdatum)) errors.push('modell_geburtsdatum');

        return errors;
    };

    const isFieldInvalid = (field: string) => invalidFields.has(field);

    const getInputClass = (baseClass: string, field: string) =>
        isFieldInvalid(field) ? `${baseClass} ${ERROR_INPUT_RING}` : baseClass;

    const clearFieldError = (field: string) => {
        setInvalidFields((prev) => {
            if (!prev.has(field)) return prev;
            const next = new Set(prev);
            next.delete(field);
            return next;
        });
    };

    const updateSalonField = <K extends keyof SalonFormData>(key: K, value: SalonFormData[K]) => {
        setSalonData((prev) => ({ ...prev, [key]: value }));
        clearFieldError(`salon_${key}`);
    };

    const updateModellField = <K extends keyof ModellFormData>(key: K, value: ModellFormData[K]) => {
        setModellData((prev) => ({ ...prev, [key]: value }));
        clearFieldError(`modell_${key}`);
    };

    const renderFieldError = (field: string) =>
        isFieldInvalid(field) ? (
            <p className="text-[10px] text-red-400 mt-1">Dieses Feld ist erforderlich</p>
        ) : null;

    const handleWeiter = () => {
        const errors = validateStep1();
        if (errors.length > 0) {
            setInvalidFields(new Set(errors));
            return;
        }
        setInvalidFields(new Set());
        setCurrentStep(2);
    };

    const handleZurueck = () => {
        setInvalidFields(new Set());
        setCurrentStep(1);
    };

    const handleClose = () => {
        setCurrentStep(1);
        setModellData(INITIAL_MODELL_DATA);
        setInvalidFields(new Set());
        setDisclaimerAccepted(false);
        setIsSaving(false);
        setArchiveFeedback('idle');
        onClose();
    };

    const isActionLocked = !disclaimerAccepted;

    const getActionButtonClass = (baseClass: string) =>
        `${baseClass} ${isActionLocked ? 'opacity-50 cursor-not-allowed' : ''}`;

    const modellAdresseInline = formatModellAdresseInline(modellData) || '____________';
    const ortDatum = `${salonData.ort || '____________'}, ${formatTodayGerman()}`;

    const getDocumentHtml = () =>
        printContainerRef.current?.innerHTML ||
        document.getElementById('pepapers-modell-release-print')?.innerHTML ||
        '';

    const buildPdfOptions = (html: string) => {
        const dateIso = new Date().toISOString().slice(0, 10);
        return {
            html,
            filename: `Modell_Release_${dateIso}.pdf`,
            scrubMode: 'minimal' as const,
            splitPrintBreaks: true as const,
            capturePadPx: 0,
            letterheadOnBreaks: false,
            fitSectionsToPage: true,
            extraCss: MR_CONTRACT_PDF_CSS,
        };
    };

    /** Druck = exakt dasselbe PDF wie Download (kein separates HTML-Print-Layout). */
    const handlePrintIsolated = async () => {
        if (isActionLocked || isPdfDownloading) return;
        const html = getDocumentHtml();
        if (!html.trim()) {
            window.alert('Dokumentinhalt fehlt — bitte Vorschau prüfen.');
            return;
        }
        setIsPdfDownloading(true);
        try {
            const blob = await buildHtmlAsPdfBlob(buildPdfOptions(html));
            const url = URL.createObjectURL(blob);
            const iframe = document.createElement('iframe');
            iframe.setAttribute('title', 'Modell-Release Druck');
            iframe.style.cssText = 'position:fixed;right:0;bottom:0;width:0;height:0;border:0;';
            document.body.appendChild(iframe);
            const cleanup = () => {
                window.setTimeout(() => {
                    iframe.remove();
                    URL.revokeObjectURL(url);
                }, 1500);
            };
            iframe.onload = () => {
                try {
                    iframe.contentWindow?.focus();
                    iframe.contentWindow?.print();
                } finally {
                    cleanup();
                }
            };
            iframe.src = url;
        } catch (err) {
            console.error('PEPapers Modell-Release Druck fehlgeschlagen:', err);
            window.alert('Druckvorschau konnte nicht erstellt werden.');
        } finally {
            setIsPdfDownloading(false);
        }
    };

    const handleDownloadPdf = async () => {
        if (isActionLocked || isPdfDownloading) return;
        const html = getDocumentHtml();
        if (!html.trim()) {
            window.alert('Dokumentinhalt fehlt — bitte Vorschau prüfen.');
            return;
        }
        setIsPdfDownloading(true);
        try {
            await downloadHtmlAsPdf(buildPdfOptions(html));
        } catch (err: any) {
            console.error('PEPapers Modell-Release PDF-Download fehlgeschlagen:', err);
            window.alert(
                'PDF konnte nicht heruntergeladen werden: ' +
                    (String(err?.message || '').match(/setEnd|Range|offset/i)
                        ? 'PDF-Erstellung ist fehlgeschlagen. Bitte Seite neu laden und erneut versuchen.'
                        : err?.message || 'Unbekannter Fehler')
            );
        } finally {
            setIsPdfDownloading(false);
        }
    };

    const handleArchive = async (asDraft = false) => {
        if (isSaving) return;
        if (!asDraft && isActionLocked) return;

        setIsSaving(true);
        setArchiveFeedback('idle');

        const htmlContent =
            printContainerRef.current?.innerHTML ||
            document.getElementById('pepapers-modell-release-print')?.innerHTML ||
            '';

        try {
            const id = await savePePapersArchiveDoc({
                id: archiveDocId,
                documentType: 'modell-release',
                status: asDraft ? 'entwurf' : 'final',
                salonName: salonData.firmenname || 'Unbekannter Salon',
                mitarbeiterName: modellData.name.trim(),
                confirmedDisclaimer: asDraft ? disclaimerAccepted : true,
                currentStep,
                payload: {
                    modellName: modellData.name.trim(),
                    salonData,
                    modellData: {
                        ...modellData,
                        adresse: formatModellAdresseInline(modellData),
                    },
                    generatedHtml: htmlContent,
                },
            });
            setArchiveDocId(id);
            setArchiveFeedback(asDraft ? 'draft' : 'success');
            onArchived?.();
            if (asDraft) {
                setTimeout(() => {
                    onClose();
                }, 600);
            } else {
                setTimeout(() => setArchiveFeedback('idle'), 3000);
            }
        } catch (error) {
            console.error('PEPapers Modell-Release Archivierung fehlgeschlagen:', error);
            setArchiveFeedback('error');
        } finally {
            setIsSaving(false);
        }
    };

    const renderSalonField = (
        field: keyof SalonFormData,
        label: string,
        options?: { type?: string; inputMode?: string }
    ) => {
        const lockKey = field as keyof SalonFieldLocks;
        const fieldId = `salon_${field}`;
        const isLocked = salonLocks[lockKey];

        return (
            <div>
                <label className={LABEL_CLASS}>{label}</label>
                <input
                    type={options?.type || 'text'}
                    name={field === 'mailadresse' ? 'email' : field === 'telefon' ? 'tel' : field}
                    autoComplete={isLocked ? 'off' : SALON_AUTOCOMPLETE[field]}
                    inputMode={options?.inputMode as React.HTMLAttributes<HTMLInputElement>['inputMode']}
                    value={salonData[field]}
                    readOnly={isLocked}
                    onChange={(e) => !isLocked && updateSalonField(field, e.target.value)}
                    className={getInputClass(isLocked ? READONLY_INPUT_CLASS : INPUT_CLASS, fieldId)}
                />
                {renderFieldError(fieldId)}
            </div>
        );
    };

    const renderContractDocument = () => (
        <div ref={printContainerRef} id="pepapers-modell-release-print" className="w-full h-auto overflow-visible">
            <style>{MR_CONTRACT_PDF_CSS}</style>
            <div className={`${A4_PREVIEW_PAGE_CLASS} min-h-[297mm]`}>
                <div className="pdf-letterhead text-center">
                    <h1>Modell-Release-Vertrag</h1>
                    <h2>PreisExpert · PEPapers · Foto- &amp; Video-Einwilligung</h2>
                </div>

                <div className="av-meta-grid">
                    <div className="av-meta-col">
                        <p className="av-meta-label">Salon / Auftraggeber</p>
                        <p>
                            <strong>{salonData.firmenname || '____________'}</strong>
                            {salonData.strasse ? (
                                <>
                                    <br />
                                    {salonData.strasse}
                                </>
                            ) : null}
                            {salonData.plz || salonData.ort ? (
                                <>
                                    <br />
                                    {[salonData.plz, salonData.ort].filter(Boolean).join(' ')}
                                </>
                            ) : null}
                            {(salonData.telefon || salonData.mailadresse) && (
                                <>
                                    <br />
                                    {[
                                        salonData.telefon ? `Tel.: ${salonData.telefon}` : '',
                                        salonData.mailadresse || '',
                                    ]
                                        .filter(Boolean)
                                        .join(' · ')}
                                </>
                            )}
                            <span className="av-meta-date">Datum: {formatTodayGerman()}</span>
                        </p>
                    </div>
                    <div className="av-meta-col">
                        <p className="av-meta-label">Modell</p>
                        <p>
                            <strong>{modellData.name || '____________'}</strong>
                            {modellData.strasse ? (
                                <>
                                    <br />
                                    {modellData.strasse}
                                </>
                            ) : null}
                            {modellData.plz || modellData.ort ? (
                                <>
                                    <br />
                                    {[modellData.plz, modellData.ort].filter(Boolean).join(' ')}
                                </>
                            ) : !modellData.strasse ? (
                                <>
                                    <br />
                                    ____________
                                </>
                            ) : null}
                            <span className="av-meta-date">
                                Geboren am: {formatGermanDate(modellData.geburtsdatum)}
                            </span>
                        </p>
                    </div>
                </div>

                <div className="av-doc-body">
                    <p className={DOC_P_CLASS}>
                        Zwischen dem Salon <strong>{salonData.firmenname || '____________'}</strong> (Auftraggeber) und
                        dem Modell <strong>{modellData.name || '____________'}</strong>, wohnhaft in{' '}
                        <strong>{modellAdresseInline}</strong>, wird folgende Vereinbarung geschlossen:
                    </p>

                    <div className="av-doc-section">
                        <h3>§ 1 Gegenstand des Vertrages</h3>
                        <p className={DOC_P_CLASS}>
                            Der Salon beabsichtigt, im Rahmen des Salonbetriebs Foto- und Videoaufnahmen des Modells zu
                            erstellen. Diese Aufnahmen dienen ausschließlich Marketing-, Werbe- und Präsentationszwecken
                            im Salon-Kontext (z. B. Vorher/Nachher-Dokumentationen, Styling-Präsentationen, Salon-Image).
                        </p>
                    </div>

                    <div className="av-doc-section">
                        <h3>§ 2 Rechteeinräumung</h3>
                        <p className={DOC_P_CLASS}>
                            Das Modell räumt dem Salon hiermit das unentgeltliche, zeitlich und räumlich unbeschränkte
                            Recht ein, die im Salon erstellten Foto- und Videoaufnahmen zu nutzen, zu vervielfältigen, zu
                            veröffentlichen und zu verbreiten. Die Nutzung umfasst insbesondere: Instagram, TikTok,
                            Facebook, die Website des Salons, Printmedien, Online-Werbung sowie Salon-Aushänge und
                            sonstige Marketingmaßnahmen des Salons.
                        </p>
                    </div>

                    <div className="av-doc-section">
                        <h3>§ 3 Namensnennung</h3>
                        <p className={DOC_P_CLASS}>
                            Eine Namensnennung des Modells ist nicht erforderlich. Der Salon ist berechtigt, die
                            Aufnahmen ohne Nennung des Namens zu verwenden.
                        </p>
                    </div>

                    <div className="av-doc-section">
                        <h3>§ 4 Vergütung</h3>
                        <p className={DOC_P_CLASS}>
                            Die Einräumung der Nutzungsrechte erfolgt unentgeltlich. Es besteht kein Anspruch des Modells
                            auf Vergütung, Provision oder sonstige Sonderzahlungen.
                        </p>
                    </div>

                    <div className="av-doc-section">
                        <h3>§ 5 Zusicherungen</h3>
                        <p className={DOC_P_CLASS}>
                            Das Modell versichert, volljährig und geschäftsfähig zu sein. Das Modell bestätigt, freiwillig
                            und ohne Zwang in diese Vereinbarung einzutreten und die Tragweite der Rechteeinräumung
                            verstanden zu haben.
                        </p>
                    </div>

                    <div className="av-doc-section">
                        <h3>§ 6 Widerrufsrecht</h3>
                        <p className={DOC_P_CLASS}>
                            Das Modell kann diese Einwilligung jederzeit schriftlich mit Wirkung für die Zukunft
                            widerrufen. Der Widerruf ist an den Salon zu richten. Bereits veröffentlichte Inhalte, deren
                            Verbreitung technisch oder wirtschaftlich nicht mehr rückgängig gemacht werden kann, bleiben
                            hiervon unberührt.
                        </p>
                    </div>

                    <div className="av-doc-section">
                        <h3>§ 7 Datenschutz</h3>
                        <p className={DOC_P_CLASS}>
                            Der Salon verarbeitet die personenbezogenen Daten des Modells ausschließlich im Rahmen der
                            DSGVO-konformen Nutzung der Aufnahmen. Das Modell wurde über Zweck, Umfang und Speicherdauer
                            der Datenverarbeitung informiert. Weitere Informationen erhält das Modell auf Anfrage beim
                            Salon.
                        </p>
                    </div>

                    <div className="av-doc-section">
                        <h3>§ 8 Sonstiges</h3>
                        <p className={DOC_P_CLASS}>
                            Änderungen und Ergänzungen dieses Vertrages bedürfen der Schriftform. Sollte eine Bestimmung
                            dieser Vereinbarung unwirksam sein, wird die Wirksamkeit der übrigen Bestimmungen hiervon
                            nicht berührt. Die Parteien verpflichten sich, die unwirksame Bestimmung durch eine
                            Vereinbarung zu ersetzen, die der unwirksamen Bestimmung in Interessenlage und Bedeutung
                            möglichst nahe kommt. Es gilt deutsches Recht. Gerichtsstand ist, soweit gesetzlich zulässig,
                            der Sitz des Salons.
                        </p>
                    </div>
                </div>

                <table
                    className="ab-sig-table"
                    style={{
                        width: '100%',
                        borderCollapse: 'collapse',
                        tableLayout: 'fixed',
                    }}
                >
                    <tbody>
                        <tr>
                            <td style={{ width: '50%', paddingRight: '20px', verticalAlign: 'top' }}>
                                <p style={{ margin: 0, fontSize: '11px', color: '#475569' }}>
                                    Ort, Datum: {ortDatum}
                                </p>
                                <div style={{ height: '32px' }} aria-hidden="true" />
                                <div
                                    style={{
                                        height: '1px',
                                        backgroundColor: '#1e293b',
                                        width: '200px',
                                        maxWidth: '100%',
                                        marginBottom: '6px',
                                    }}
                                    aria-hidden="true"
                                />
                                <p style={{ margin: 0, fontSize: '11px', fontWeight: 600, color: '#0f172a' }}>
                                    Unterschrift Salon / Auftraggeber
                                </p>
                                <p style={{ margin: 0, fontSize: '11px', color: '#64748b' }}>
                                    {salonData.firmenname || 'Salon'}
                                </p>
                            </td>
                            <td style={{ width: '50%', paddingLeft: '20px', verticalAlign: 'top' }}>
                                <p style={{ margin: 0, fontSize: '11px', color: '#475569' }}>
                                    Ort, Datum: ________________________
                                </p>
                                <div style={{ height: '32px' }} aria-hidden="true" />
                                <div
                                    style={{
                                        height: '1px',
                                        backgroundColor: '#1e293b',
                                        width: '200px',
                                        maxWidth: '100%',
                                        marginBottom: '6px',
                                    }}
                                    aria-hidden="true"
                                />
                                <p style={{ margin: 0, fontSize: '11px', fontWeight: 600, color: '#0f172a' }}>
                                    Unterschrift Modell
                                </p>
                                <p style={{ margin: 0, fontSize: '11px', color: '#64748b' }}>
                                    {modellData.name || 'Modell'}
                                </p>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    );

    if (!isOpen) return null;

    const modalWidthClass = currentStep === 2 ? 'max-w-4xl' : 'max-w-lg';

    return createPortal(
        <>
            <div
                className="fixed inset-0 bg-stone-900/70 dark:bg-black/90 z-[100000] backdrop-blur-md print:hidden"
                onClick={handleClose}
                aria-hidden="true"
            />
            <div className="fixed inset-x-0 top-[8.5rem] md:top-36 bottom-0 z-[100001] flex items-start justify-center overflow-hidden p-4 pb-8 font-sans print:inset-0 print:top-0 print:overflow-visible print:p-0">
                <div
                    className={`bg-pe-card dark:bg-[#111] rounded-2xl shadow-[0_0_40px_rgba(230,194,153,0.1)] border border-[#E6C299]/30 w-full ${modalWidthClass} max-h-[calc(100vh-9.5rem)] md:max-h-[calc(100vh-10rem)] flex min-h-0 flex-col justify-between overflow-hidden relative transition-all duration-200 my-2 print:shadow-none print:border-0 print:max-w-none print:max-h-none print:rounded-none print:my-0 print:bg-white`}
                    onClick={(e) => e.stopPropagation()}
                >
                    <button
                        type="button"
                        onClick={handleClose}
                        className="absolute top-4 right-4 text-pe-muted dark:text-slate-400 hover:text-pe-text dark:hover:text-white bg-pe-elevated dark:bg-[#1a1a1a] hover:bg-pe-hover dark:hover:bg-[#222] rounded-lg p-2 transition-colors border border-pe-border-strong dark:border-[#333] z-[60] print:hidden"
                        aria-label="Schließen"
                    >
                        <X className="w-4 h-4" />
                    </button>

                    <div className="bg-pe-elevated dark:bg-[#111622] z-50 shrink-0 print:hidden border-b border-pe-border dark:border-[#222]">
                        <div className="px-6 pt-10 pb-4">
                            <h3 className="text-lg font-bold text-pe-accent-text dark:text-[#E6C299] text-center uppercase tracking-widest pr-8">
                                Modell-Release-Vertrag
                            </h3>
                            <p className="text-center text-xs text-pe-muted dark:text-slate-400 uppercase tracking-widest mt-2">
                                Schritt {currentStep} von 2: {STEP_LABELS[currentStep]}
                            </p>
                        </div>
                    </div>

                    <div className="flex-1 min-h-0 overflow-y-auto px-6 py-5 custom-scrollbar print:p-0 print:overflow-visible">
                        {currentStep === 1 && (
                            <div className="space-y-6">
                                <div>
                                    <p className="text-[10px] font-bold uppercase tracking-widest text-pe-accent-text dark:text-[#E6C299]/80 mb-3 border-b border-pe-border dark:border-[#222] pb-2">
                                        Salon-Daten
                                    </p>
                                    <div className="space-y-4">
                                        {renderSalonField('firmenname', 'Firma / Salonname')}
                                        {renderSalonField('strasse', 'Straße & Hausnummer')}
                                        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
                                            {renderSalonField('plz', 'PLZ')}
                                            <div className="sm:col-span-2">{renderSalonField('ort', 'Ort')}</div>
                                        </div>
                                        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                                            {renderSalonField('telefon', 'Telefon', { inputMode: 'tel' })}
                                            {renderSalonField('mailadresse', 'E-Mail', { type: 'email' })}
                                        </div>
                                    </div>
                                </div>

                                <div>
                                    <p className="text-[10px] font-bold uppercase tracking-widest text-pe-accent-text dark:text-[#E6C299]/80 mb-3 border-b border-pe-border dark:border-[#222] pb-2">
                                        Modell-Daten
                                    </p>
                                    <div className="space-y-4">
                                        <div>
                                            <label className={LABEL_CLASS} htmlFor="mr-modell-name">
                                                Name des Modells
                                            </label>
                                            <input
                                                id="mr-modell-name"
                                                type="text"
                                                name="name"
                                                autoComplete="name"
                                                value={modellData.name}
                                                onChange={(e) => updateModellField('name', e.target.value)}
                                                className={getInputClass(INPUT_CLASS, 'modell_name')}
                                            />
                                            {renderFieldError('modell_name')}
                                        </div>
                                        <div>
                                            <label className={LABEL_CLASS} htmlFor="mr-modell-strasse">
                                                Straße &amp; Hausnummer
                                            </label>
                                            <input
                                                id="mr-modell-strasse"
                                                type="text"
                                                name="strasse"
                                                autoComplete="street-address"
                                                value={modellData.strasse}
                                                onChange={(e) => updateModellField('strasse', e.target.value)}
                                                placeholder="z. B. Musterstraße 12"
                                                className={getInputClass(INPUT_CLASS, 'modell_strasse')}
                                            />
                                            {renderFieldError('modell_strasse')}
                                        </div>
                                        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
                                            <div>
                                                <label className={LABEL_CLASS} htmlFor="mr-modell-plz">
                                                    PLZ
                                                </label>
                                                <input
                                                    id="mr-modell-plz"
                                                    type="text"
                                                    name="plz"
                                                    autoComplete="postal-code"
                                                    inputMode="numeric"
                                                    value={modellData.plz}
                                                    onChange={(e) => updateModellField('plz', e.target.value)}
                                                    placeholder="12345"
                                                    className={getInputClass(INPUT_CLASS, 'modell_plz')}
                                                />
                                                {renderFieldError('modell_plz')}
                                            </div>
                                            <div className="sm:col-span-2">
                                                <label className={LABEL_CLASS} htmlFor="mr-modell-ort">
                                                    Ort
                                                </label>
                                                <input
                                                    id="mr-modell-ort"
                                                    type="text"
                                                    name="ort"
                                                    autoComplete="address-level2"
                                                    value={modellData.ort}
                                                    onChange={(e) => updateModellField('ort', e.target.value)}
                                                    placeholder="Musterstadt"
                                                    className={getInputClass(INPUT_CLASS, 'modell_ort')}
                                                />
                                                {renderFieldError('modell_ort')}
                                            </div>
                                        </div>
                                        <div>
                                            <label className={LABEL_CLASS} htmlFor="mr-modell-geburt">
                                                Geburtsdatum
                                            </label>
                                            <input
                                                id="mr-modell-geburt"
                                                type="text"
                                                name="bday"
                                                autoComplete="bday"
                                                value={modellData.geburtsdatum}
                                                onChange={(e) => updateModellField('geburtsdatum', e.target.value)}
                                                placeholder="TT.MM.JJJJ"
                                                className={getInputClass(INPUT_CLASS, 'modell_geburtsdatum')}
                                            />
                                            {renderFieldError('modell_geburtsdatum')}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}

                        {currentStep === 2 && (
                            <div className="w-full min-h-0 pr-2 mb-6">{renderContractDocument()}</div>
                        )}
                    </div>

                    {currentStep === 2 && (
                        <PePapersDisclaimerGate
                            accepted={disclaimerAccepted}
                            onAcceptedChange={setDisclaimerAccepted}
                        />
                    )}

                    <div className="px-6 py-4 border-t border-pe-border dark:border-[#222] shrink-0 print:hidden">
                        <div className="flex flex-wrap gap-3">
                            {currentStep > 1 && (
                                <button
                                    type="button"
                                    onClick={handleZurueck}
                                    className="flex-1 min-w-[120px] px-4 py-3 font-bold rounded-xl text-xs uppercase tracking-widest border bg-transparent hover:bg-pe-hover dark:hover:bg-[#222] border-pe-border-strong dark:border-[#444] text-pe-muted dark:text-gray-300 transition-colors"
                                >
                                    Zurück
                                </button>
                            )}

                            {currentStep === 1 ? (
                                <>
                                    <button
                                        type="button"
                                        onClick={() => void handleArchive(true)}
                                        disabled={isSaving}
                                        className="flex-1 min-w-[120px] px-4 py-3 font-bold rounded-xl text-xs uppercase tracking-widest border bg-transparent hover:bg-pe-hover dark:hover:bg-[#222] border-pe-border-strong dark:border-[#444] text-pe-muted dark:text-gray-300 transition-colors disabled:opacity-50"
                                    >
                                        {isSaving && archiveFeedback !== 'draft' ? 'Speichert...' : 'Später fortsetzen'}
                                    </button>
                                    <button
                                        type="button"
                                        onClick={handleWeiter}
                                        className="flex-1 min-w-[120px] px-4 py-3 font-bold rounded-xl text-xs uppercase tracking-widest bg-[#E6C299] hover:bg-[#d9b183] dark:hover:bg-white text-black transition-colors"
                                    >
                                        Dokument erstellen
                                    </button>
                                </>
                            ) : (
                                <>
                                    <button
                                        type="button"
                                        onClick={() => void handleArchive(true)}
                                        disabled={isSaving}
                                        className="flex-1 min-w-[140px] px-4 py-3 font-bold rounded-xl text-xs uppercase tracking-widest border bg-transparent hover:bg-pe-hover dark:hover:bg-[#222] border-pe-border-strong dark:border-[#444] text-pe-muted dark:text-gray-300 transition-colors disabled:opacity-50"
                                    >
                                        {archiveFeedback === 'draft' ? 'Gespeichert! ✓' : 'Später fortsetzen'}
                                    </button>
                                    <button
                                        type="button"
                                        onClick={() => void handleArchive(false)}
                                        disabled={isActionLocked || isSaving}
                                        className={getActionButtonClass(
                                            'flex-1 min-w-[140px] px-4 py-3 font-bold rounded-xl text-xs uppercase tracking-widest border bg-pe-card dark:bg-[#15171e] hover:bg-pe-hover dark:hover:bg-[#1a1d24] border-[#E6C299]/40 text-pe-accent-text dark:text-[#E6C299] transition-colors'
                                        )}
                                    >
                                        {isSaving && archiveFeedback !== 'draft'
                                            ? 'Speichert...'
                                            : archiveFeedback === 'success'
                                              ? 'Gespeichert! ✓'
                                              : 'Im Archiv speichern'}
                                    </button>
                                    <button
                                        type="button"
                                        onClick={() => void handleDownloadPdf()}
                                        disabled={isActionLocked || isPdfDownloading}
                                        className={getActionButtonClass(
                                            'flex-1 min-w-[140px] px-4 py-3 font-bold rounded-xl text-xs uppercase tracking-widest bg-gradient-to-b from-[#E6C299] to-[#b48a56] hover:from-[#f0d3b3] hover:to-[#cfa674] text-black transition-colors'
                                        )}
                                    >
                                        {isPdfDownloading ? 'PDF wird erstellt...' : 'Als PDF herunterladen'}
                                    </button>
                                    <button
                                        type="button"
                                        onClick={() => void handlePrintIsolated()}
                                        disabled={isActionLocked}
                                        className={getActionButtonClass(
                                            'flex-1 min-w-[140px] px-4 py-3 font-bold rounded-xl text-xs uppercase tracking-widest border bg-transparent hover:bg-pe-hover dark:hover:bg-[#222] border-[#E6C299]/40 text-pe-accent-text dark:text-[#E6C299] transition-colors'
                                        )}
                                    >
                                        Ausdrucken
                                    </button>
                                </>
                            )}
                        </div>
                        {currentStep === 2 && archiveFeedback === 'error' && (
                            <p className="text-[10px] text-red-400 mt-2 text-center">
                                Archivierung fehlgeschlagen. Bitte erneut versuchen.
                            </p>
                        )}
                    </div>
                </div>
            </div>
        </>,
        document.body
    );
};

export default ModellReleaseModal;
